import { overlay } from 'overlay-kit'

import Dialog from '@ahha/stableComponents/Dialog/Dialog'
import { useI18n } from '@ahha/i18n/i18n'

import { UNIQUE_CODES } from '@/api/react-query/const'

// 학습 제외 영역(마스킹 오브젝트)과 라벨링 오브젝트가 서로 겹칠 때 노출하는 안내 다이얼로그.
// 오브젝트 생성/수정/undo/redo 시 서버가 uniqueCode 6000021로 내려준다.
interface MaskingOverlapDialogProps {
  isOpen: boolean
  onClose: () => void
}

const MaskingOverlapDialog = ({ isOpen, onClose }: MaskingOverlapDialogProps) => {
  const { t } = useI18n()

  return (
    <Dialog
      open={isOpen}
      height="auto"
      title={t('labeling_exclusionArea_overlap_dialog_title')}
      content={<p style={{ fontSize: '0.875rem', lineHeight: '1.375rem' }}>{t('labeling_exclusionArea_overlap_dialog_desc')}</p>}
      showCloseButton
      onClose={onClose}
      confirmText={t('common_confirm')}
      confirmAction={onClose}
    />
  )
}

// 단축키 연타 등으로 겹침 에러가 연속 발생해도 다이얼로그가 중첩되지 않도록 막는 가드
let isMaskingOverlapDialogOpen = false

export const isMaskingOverlapError = (error: unknown) => (
  (error as { response?: { data?: { unique_code?: number } } })?.response?.data?.unique_code === UNIQUE_CODES.LABELING_OBJECT_MASKING_OVERLAP
)

export const openMaskingOverlapDialog = () => {
  if (isMaskingOverlapDialogOpen) {
    return
  }
  isMaskingOverlapDialogOpen = true

  overlay.open(({ isOpen, close }) => {
    const handleClose = () => {
      isMaskingOverlapDialogOpen = false
      close()
    }

    return <MaskingOverlapDialog isOpen={isOpen} onClose={handleClose} />
  })
}

export default MaskingOverlapDialog
